import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const haveLoadedInstance = (state, instance) => state.some((item) => item.campaignId === instance.campaignId);

export const campaignsSlice = createSlice({
  name: 'campaigns',
  initialState: initialState,
  reducers: {
    clearCampaigns: () => {
      return initialState;
    },

    addCampaign: (state, action) => {
      const instance = action.payload;
      return haveLoadedInstance(state, instance) ? state : state.concat(instance);
    },

    modifyCampaign: (state, action) => {
      const instance = action.payload;
      if (!haveLoadedInstance(state, instance)) {
        return state;
      } else {
        const others = state.filter((c) => c.campaignId !== instance.campaignId);
        return [...others, instance];
      }
    },
  },
});

export const { clearCampaigns, addCampaign, modifyCampaign } = campaignsSlice.actions;

export default campaignsSlice.reducer;
